import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        "flex-direction": "row",
        "justify-content": "center",
        marginLeft: "3rem",
        alignItems: "center",
        height: "75vh",
        width: "93vw",
        backgroundColor: "transparent",
    },
    boxPrancheta: {
        backgroundColor: "white",
        height: "75vh",
        width: "93vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    },
    boxDataGrid: {
        "& .header_grid": {
            backgroundColor: "#2471A3",
            color: "white",
        },
        height: "75vh",
        width: "93vw",

        "& .MuiDataGrid-row.Mui-even:not(:hover)": {
            backgroundColor: "#D6EAF8",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-odd:not(:hover)": {
            backgroundColor: "#93b7d9",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-selected:not(:hover)": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row:hover": {
            backgroundColor: "#D3D3D3",
            color: "black",
        },
    },
    side_content: {
        display: "grid",
        overflow: "auto",
    },
    nome: {
        width: "400px",
    },
    header_grid: {
        backgroundColor: "#2471A3", //dark-blue
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        paddingTop: "100px",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
